import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import isEqual from "lodash/isEqual";
import {
  filterAccountabilityAttrs,
  isStateFilled,
} from "../../../../../../utils/daily-accountability";
import AccountabilityCard from "../../../../../../parts/cards/profile-accountability";

const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const days = {};
weekDays.forEach((day) => (days[day] = false));
const newItem = {
  title: "",
  description: "",
  days,
  editing: true,
  adding: true,
};
export const EditDailyAccountability = ({
  _id,
  nameProp,
  list,
  widget,
  startingCalendarDay = 0,
}) => {
  const [name, setName] = useState(nameProp || "");
  const [listState, setListState] = useState(list || [newItem]);
  const [adding, setAdding] = useState(!list);

  const changed = useMemo(() => {
    return !isEqual(listState, list || [newItem]);
  }, [listState, list]);

  const addItem = () => {
    setAdding(true);
    setListState((prev) =>
      prev.map((item) => ({ ...item, editing: false })).concat(newItem)
    );
  };

  const handleEditing = (i) => {
    setListState((prev) =>
      prev.map((item, index) =>
        index === i ? { ...item, editing: true } : { ...item, editing: false }
      )
    );
  };

  const { t } = useTranslation("coaching-portal");
  const removeItem = (i) => {
    if (
      process.browser &&
      confirm(t("widgets.editDailyAccountability.confirmDeleteHabit"))
    ) {
      setListState((prev) => prev.filter((_, index) => index !== i));
    }
  };

  const saveChanges = (e) => {
    e.preventDefault();
    setAdding(false);
    setListState((prev) => prev.map((item) => ({ ...item, editing: false })));
    submit(`/actions/widget-daily-accountability/save/${_id}`, {
      method: "POST",
      body: {
        widget,
        name,
        list: listState.map((item) => filterAccountabilityAttrs(item)),
      },
    });
  };

  const canSubmit = isStateFilled(listState);

  return (
    <form onSubmit={saveChanges}>
      <div className="w-[340px] mb-8">
        <label htmlFor="name"> {t("widgets.editDailyAccountability.templateName")}</label>
        <input
          name="name"
          className="text-input"
          placeholder={t("widgets.common.enterName")}
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      {listState?.length > 0 &&
        listState.map((item, index) => (
          <AccountabilityCard
            key={item._id || index}
            id={index}
            setState={setListState}
            state={listState}
            adding={item.adding || false}
            handleEditing={handleEditing}
            removeItem={removeItem}
            startingCalendarDay={startingCalendarDay}
          />
        ))}

      <footer>
        <button
          data-button-type="outline"
          onClick={addItem}
          type="button"
          disabled={adding}
        >
          {t("widgets.editDailyAccountability.addNew")}
        </button>
        <button
          data-button-type="primary"
          type="submit"
          className="save-macro-btn"
          disabled={!changed || !canSubmit}
        >
          {t("widgets.common.save")}
        </button>
      </footer>
    </form>
  );
};
